module.exports = __webpack_public_path__ + "img/62903dac9ba9d12549363dc5a2f2ec62.7273e20d.jpg";